import { jsx as _jsx } from "react/jsx-runtime";
export const WkoLoadingSpinner = () => {
    return (_jsx("div", { className: "spinner-grow text-primary", role: "status", children: _jsx("span", { className: "visually-hidden", children: "Loading..." }) }));
};
